//
import { mapActions } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'

//
import ProviderModel from '@/models/Purchase/PchProvider'
import fields from './fields'

//
export default {
    name: 'provider-update',
    components: {
        'model-form': ModelForm,
    },
    computed: {
        /**
         *
         */
        formProps() {
            return {
                fields: fields({ pch_provider_id: this.$route.params.id }),
                loading: this.busy,
            }
        },
    },
    data() {
        return {
            busy: false,
            formData: {},
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        fetch() {
            this.busy = true
            ProviderModel.modeler()
                .find(this.$route.params.id)
                .then(this.setFormData)
        },

        /**
         *
         */
        reset() {
            this.fetch()
        },

        /**
         *
         */
        setFormData(model) {
            this.busy = false
            this.formData = model.clone().reset()
        },
    },
    beforeMount() {
        this.setTitleTopBar('Datos del proveedor')
    },
    mounted() {
        this.reset()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_PURCHASE_PROVIDER'))
                ctx.$router.push('/')
        })
    },
}
